import { render, staticRenderFns } from "./InLearningFormularioATC.vue?vue&type=template&id=08bed5a0&"
import script from "./InLearningFormularioATC.vue?vue&type=script&lang=js&"
export * from "./InLearningFormularioATC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports